import React, { useEffect, useState } from 'react';
import _axios from "../../httpService";
import Loader from "../Loader";
import objectDataHolder from "../Hooks/ObjectDataHolder";
import FactorJoz from './FactorJoz/FactorJoz';
import FactorKol from './FactorKol/FactorKol';
import "./FormInstitutes.scss";
import CardLearner from './CardLearner';
import ModalLearner from "./ModalLearner";
import imageBackend from "../../Assets/Images/لوگو ورکان 2 1.png";

const FormInstitutes = () => {
    const [loader, setLoader] = useState(true)

    const [showModal, setShowModal] = useState(false);

    const [initialData, setInitialData] = objectDataHolder({
        options: [
            { value: "option1", label: "12345 لورم ایپسوم متن فارسی" },
            { value: "option2", label: "12345 لورم ایپسوم متن فارسی" },
            { value: "option3", label: "12345 لورم ایپسوم متن فارسی" },
        ],
        factorOptions: [
            { value: "option1", label: "12345 شنبه | شروع:10:00 | پایان:12:00" },
            { value: "option2", label: "12345 یکشنبه | شروع:12:00 | پایان:14:00" },
            { value: "option3", label: "12345 دوشنبه | شروع:14:00 | پایان:16:00" },
        ],
        TableData: [
            { ClassCode: 12345, ClassTitel: 'لورم ایپسوم' },
            { ClassCode: 12345, ClassTitel: 'لورم ایپسوم' },
            { ClassCode: 12345, ClassTitel: 'لورم ایپسوم' }
        ],
        photo: { url: "" }
    })

    useEffect(() => {
        _axios.get('https://jsonplaceholder.typicode.com/posts').then(res => {

            setInitialData({ ...initialData })
            setLoader(false)

        })


    }, []);

    return (
        <>
            {loader ? <Loader /> :
                <>
                    <div className='FactorFormInstitutes'>
                        <div className='FactorKol'>
                            <FactorKol factorOptions={initialData.factorOptions} options={initialData.options} />
                        </div>
                        <div className='FactorJoz'>
                            <FactorJoz initialData={initialData} />
                        </div>
                    </div>

                    {showModal && <ModalLearner
                        photo={initialData.photo}
                        setShowModal={setShowModal}
                        onClose={() => setShowModal(false)} />
                    }

                    <button onClick={(e) => {
                        setShowModal(true)
                    }}>نمایش مودال</button>
                </>
            }
        </>
    );
};

export default FormInstitutes;
